export default "__VITE_ASSET__CW$HudjO__"